import { useFetchList } from 'store'
import { RequisitionType } from 'utils/enums'
import { ClinicalProcess } from 'models'
import MedicalActsRequisitionDetails from './MedicalActsRequisitionDetails'
import SurgeryRequisitionDetails from './SurgeryRequisitionDetails'
import NonSurgicalRequisitionDetails from './NonSurgicalRequisitionDetails'

const RequisitionDetails = (props) => {
	const { requisition } = props

	const requisitionType = requisition?.type?.id

	const processUri = `/clinical_processes/${requisition?.processId}`

	const {
		contents: [process],
	} = useFetchList([processUri], [ClinicalProcess.fromJSON])

	switch (requisitionType) {
		case RequisitionType.Surgery:
			return (
				<SurgeryRequisitionDetails
					requisition={requisition}
					process={process}
				/>
			)
		case RequisitionType.NonSurgical:
			return <NonSurgicalRequisitionDetails requisition={requisition} />
		default:
			return <MedicalActsRequisitionDetails requisition={requisition} />
	}
}

export default RequisitionDetails
